<template>
  <ion-page>
    <ion-content>
      <div class="ion-padding">
        <DeviceGroupForm :device-group="deviceGroup" :uuid="deviceGroup.uuid" ref="form" />
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <gro-button fill="clear"
                    @click="close">
          {{ $t('common.Cancel') }}
        </gro-button>
        <ion-buttons slot="end">
          <gro-button v-if="deviceGroup.devices.length > 0"
                      @click="unassignDevices"
                      color="danger">
            {{ $t('deviceGroup.Unassign') }}
          </gro-button>
          <gro-button v-else
                      @click="deleteGroup"
                      color="danger">
            {{ $t('deviceGroup.Delete') }}
          </gro-button>
          <gro-button @click="saveGroup">
            {{ $t('common.Save') }}
          </gro-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script>
import DeviceGroupForm from '~gro-components/forms/DeviceGroupForm'

export default {
  components: {
    DeviceGroupForm,
  },
  props: {
    deviceGroup: {
      type: Object,
      required: true,
    },
    refetch: {
      type: Function,
    },
  },
  methods: {
    close () {
      this.$dismissAllModals()
    },
    async saveGroup () {
      if (await this.$refs.form.submit()) {
        await this.refetch()
        return this.close()
      }
    },
    async unassignDevices () {
      if (await this.$refs.form.unassignDevices()) {
        await this.refetch()
        return this.close()
      }
    },
    async deleteGroup () {
      if (await this.$refs.form.deleteGroup()) {
        await this.refetch()
        return this.close()
      }
    },
  },
}
</script>
